import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2 as Grid,
  TextField,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { WButton } from '@wareclouds/wareclouds-ui';

const formSchema = yup.object().shape({
  code: yup.string().required(),
});

export default function ManualDeliveryDialog({
  onClose,
  onManualDelivery,
  isLoading,
}) {
  const { t } = useTranslation(['form', 'button', 'title']);

  const {
    handleSubmit,
    control,
    formState: { isValid, isDirty },
  } = useForm({
    defaultValues: { code: '' },
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data) => {
    onManualDelivery(data.code);
  };

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogTitle>
        {t('orders.crossdocking.manual_delivery', { ns: 'title' })}
      </DialogTitle>

      <DialogContent>
        <Grid
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          container
          spacing={2}
        >
          <Grid size={12} sx={{ mt: 1 }}>
            <Controller
              control={control}
              name="code"
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('orders.crossdocking.code.label', { ns: 'form' })}
                  fullWidth
                  placeholder={t('orders.crossdocking.code.placeholder', {
                    ns: 'form',
                  })}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>

          <Grid container size={12} spacing={1}>
            <Grid size={12}>
              <WButton
                variant="contained"
                type="submit"
                label={t('confirm', { ns: 'button' })}
                color="primary"
                fullWidth
                isDisabled={!isValid || !isDirty || isLoading}
                isLoading={isLoading}
              />
            </Grid>

            <Grid size={12}>
              <WButton
                type="button"
                label={t('close', { ns: 'button' })}
                variant="outlined"
                color="primary"
                fullWidth
                isDisabled={isLoading}
                onClick={onClose}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
